export default class NavigationToggle {
  constructor(el) {
    this.el = el;

    el.addEventListener('click', this.handleClicks);
  }

  handleClicks(event) {
    const headerEl = document.querySelector('[data-header]');
    const navEl = document.querySelector('[data-nav]');
    event.stopPropagation();
    event.preventDefault();

    document.documentElement.classList.toggle('s-menu-open');
    event.target.classList.toggle('is-active');

    navEl.style.height = `calc(100vh - ${
      headerEl.getBoundingClientRect().height +
      headerEl.getBoundingClientRect().top
    }px)`;
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/NavigationToggle.js